// Shared helper to fire a Facebook Pixel event and forward the same event
// (with the same eventId) to our server-side Conversions API endpoint, so
// Facebook dedupes the two instead of double-counting the lead.

function getCookie(name) {
  const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : null;
}

function generateEventId() {
  if (window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID();
  }
  return `lead_${Date.now()}_${Math.random().toString(36).slice(2)}`;
}

// contentName: human-readable label for which form this is (e.g. "Drop a Query")
// email/phone/firstName/lastName: raw values from the form (hashed server-side, never here)
export function trackLead({ contentName, email, phone, firstName, lastName }) {
  const eventId = generateEventId();

  if (window.fbq) {
    window.fbq("track", "Lead", { content_name: contentName }, { eventID: eventId });
  }

  const endpoint = process.env.REACT_APP_FB_CONVERSION_ENDPOINT;
  if (!endpoint) return;

  fetch(endpoint, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    keepalive: true,
    body: JSON.stringify({
      eventId,
      eventName: "Lead",
      contentName,
      email,
      phone,
      firstName,
      lastName,
      sourceUrl: window.location.href,
      fbp: getCookie("_fbp"),
      fbc: getCookie("_fbc"),
    }),
  }).catch(() => {
    // Non-blocking: the lead still goes to Zoho even if this ping fails.
  });
}
